// extracted by mini-css-extract-plugin
export var active = "_gh-2";
export var recordingDot = "_gh-1";
export var recordingIndicator = "_gh-0";